import { render, staticRenderFns } from "./PageLoadData.vue?vue&type=template&id=65d00a30&scoped=true"
import script from "./PageLoadData.vue?vue&type=script&lang=js"
export * from "./PageLoadData.vue?vue&type=script&lang=js"
import style0 from "./PageLoadData.vue?vue&type=style&index=0&id=65d00a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d00a30",
  null
  
)

export default component.exports